// extracted by mini-css-extract-plugin
export default {"cls1":"EcsuaIHUv9bJhS4n6s_g","cls2":"f1C225tJr3nf5R6DHKQh EcsuaIHUv9bJhS4n6s_g"};